//TODO: this seems to rely on some Intercom global

/* eslint-disable */

export const openHelpWidget = () => {
    if (App.Models.featuresConfig.isIntercomEnabled()) {
        Intercom(`show`);
    }
};

export const closeHelpWidget = () => {
    if (App.Models.featuresConfig.isIntercomEnabled()) {
        Intercom(`hide`);
    }
};

export const setupIntercom = (toggleCallback) => {
    Intercom(`update`, {
        hide_default_launcher: false
    });
    Intercom(`onShow`, () => {
        Intercom(`update`, {
            hide_default_launcher: false
        });
        toggleCallback(true);
    });
    Intercom(`onHide`, () => {
        Intercom(`update`, {
            hide_default_launcher: true
        });
        toggleCallback(false);
    });
};

export const initializeIntercom = (window) => {
    window.intercomSettings = {
        api_base: `https://api-iam.intercom.io`,
        app_id: `nb3y3mbb`,
        alignment: `left`,
        horizontal_padding: 70,
        vertical_padding: 10,
        hide_default_launcher: true
    };

    // The following code is provided by intercom and need not be changed
    var ic = window.Intercom;
    if (typeof ic === `function`) {
        ic(`reattach_activator`);
        ic(`update`, window.intercomSettings);
    } else {
        var d = document;
        var i = function () {
            i.c(arguments);
        };
        i.q = [];
        i.c = function (args) {
            i.q.push(args);
        };
        window.Intercom = i;
        var l = function () {
            var s = d.createElement(`script`);
            s.type = `text/javascript`;
            s.async = true;
            s.src = `https://widget.intercom.io/widget/nb3y3mbb`;
            var x = d.getElementsByTagName(`script`)[0];
            x.parentNode.insertBefore(s, x);
        };
        if (document.readyState === `complete`) {
            l();
        } else if (window.attachEvent) {
            window.attachEvent(`onload`, l);
        } else {
            window.addEventListener(`load`, l, false);
        }
    }
};

export const updateIntercom = (window, user, organisation, intercomHash) => {
    window.Intercom(`update`, {
        user_hash: intercomHash,
        name: user.name,
        email: user.email,
        company: {
            company_id: organisation.organizationId,
            name: organisation.name,
            hubspot_company_record_id: organisation.hubspotCompanyRecordId
                ? organisation.hubspotCompanyRecordId
                : null
        }
    });
};
